{
  "lang": "nl",
  "alias": "mindkorrelatie",
  "theme": "template-grid",
  "master": "masters/template-grid/mindkorrelatie",
  "plugins": [
    "a11y-describedby",
    "a11y-user-detect",
    "asterisk",
    "bb-xarea",
    "c-anchors",
    "case-template",
    "chapters",
    "custom-checkboxes",
    "custom-radios",
    "form-group",
    "hacks:preview-md",
    "hacks:preview-path",
    "headings",
    "hint-to-info",
    "history",
    "horizontal-radio",
    "jquery.xarea",
    "md-labels",
    "modelitem",
    "modes",
    "nonce-metatag",
    "nta:proxymap",
    "piwik-pro-nonce",
    "previews",
    "progressbar",
    "rvr:final-node",
    "screentitle",
    "shout-out-resize",
    "show-server-side-validation",
    "showdown",
    "showdown-converter",
    "style-datepicker"
  ],
  "overrideinloghtml": "mind.html",
  "a11y": {
    "captions": false,
    "optionfieldsets": false
  },
  "arbitrary": {
    "form-group": {
      "layoutmap": {
        "checkbox": "inline",
        "radio": "below",
        "memo": "below"
      }
    },
    "horizontal-radio": {
      "max_label": 25
    },
    "core": {
      "skipNumButtons": true
    },
    "previews": {
      "autoload": true,
      "singular": true,
      "showChanges": false,
      "inline": true,
      "only": {
        "Rechtwijzer_EHBO": {
          "main": {
            "document": true
          }
        }
      }
    },
    "parentDomain": "*",
    "piwik": {
      "fallback": {
        "code": "1cb006c7-51c6-4a48-a7bf-ebd3e28b0fd1",
        "endpoint": "https://rvr.containers.piwik.pro/"
      }
    }
  },
  "template": {
    "favicon": "images/favicon-16x16.png",
    "prior-in-backbutton-position": true,
    "less": {
      "post": [
        "vars.less",
        "tweaks.less"
      ]
    },
    "elements": {
      "header": false,
      "overview": true,
      "model": true,
      "login": true
    },
    "readonly-prop": "disabled"
  },
  "legacy": false,
  "fonts": [
    "open-sans-v20/latin-ext",
    "open-sans-v20"
  ]
}
